export const GENERIC_PAYMENT_ERROR = "Error al iniciar el pago. Intenta nuevamente.";
export const GENERIC_SUBSCRIPTION_ERROR = "Error al iniciar la suscripción. Intenta nuevamente.";
export const SUBSCRIPTION_EXISTS_MESSAGE = "Ya tienes una suscripción activa. Cancélala primero para cambiar de plan.";

export async function readFunctionError(error: unknown): Promise<string | null> {
  const context = (error as { context?: { json?: () => Promise<unknown> } } | null)?.context;
  if (!context?.json) return null;
  try {
    const body = await context.json();
    const message = (body as { error?: unknown } | null)?.error;
    return typeof message === "string" && message.trim() ? message : null;
  } catch {
    return null;
  }
}

export function customerFacingError(message: string, fallback: string = GENERIC_PAYMENT_ERROR): string {
  const clean = message.trim();
  if (!clean || clean.length > 160) return fallback;
  if (/MercadoPago API \[|payment_strategy=|^\{|Failed to fetch|non-2xx status/i.test(clean)) return fallback;
  return clean;
}

export function subscriptionStartErrorMessage(err: unknown): string {
  const code = (err as { code?: unknown } | null)?.code;
  const message = err instanceof Error ? err.message : "";
  if (code === "preapproval_exists" || message.includes("preapproval_exists")) return SUBSCRIPTION_EXISTS_MESSAGE;
  return customerFacingError(message, GENERIC_SUBSCRIPTION_ERROR);
}
